import React from "react";
import { CheckIcon, ClockIcon, CancelIcon, ReplyIcon } from "common/SVG";
import { Typography, TableCellList } from "common";
import { format } from "date-fns";
import { formatUSDCurrency } from "core/utils/formatters";
import classNames from "core/utils/classNames";
import { useStyles } from "./OfferHistoryStatusTableCell.styles";

export function OfferHistoryStatusTableCell({
  status,
  offerAmount,
  offerDate
}) {
  const classes = useStyles();
  const StatusDisplay = function getStatusDisplay() {
    switch (status) {
      case "Awarded":
        return <CheckIcon className={classNames(classes.success)} />;
      case "Declined":
      case "Declined/Lane":
      case "Declined/Equipment":
        return <CancelIcon className={classNames(classes.error)} />;
      case "Expired":
        return <ClockIcon className={classNames(classes.error)} />;
      case "Countered":
        return <ReplyIcon className={classNames(classes.reply)} />;
      default:
        return null;
    }
  };

  return (
    <TableCellList
      alignContent="between"
      className={classNames(classes.row)}
      row
    >
      <li>
        <Typography
          className={classNames(classes.root)}
          component="div"
          fontSize="large"
          color="dark"
        >
          {StatusDisplay()}
          {status}
        </Typography>
      </li>
      <li style={{ paddingLeft: "0" }}>
        <TableCellList>
          <Typography label component="div" value="Offer" />
          <Typography
            fontWeight="bold"
            fontSize="medium"
            component="div"
            value={formatUSDCurrency(offerAmount)}
          />
          <Typography label component="div" value="Date" />
          <Typography
            fontWeight="bold"
            fontSize="medium"
            component="div"
            value={offerDate}
          />
        </TableCellList>
      </li>
    </TableCellList>
  );
}
